(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GeCode", [], factory);
	else if(typeof exports === 'object')
		exports["GeCode"] = factory();
	else
		root["GeCode"] = factory();
})(window, function() {
return 